import React from 'react';
import { Link } from 'react-router-dom';
import { FacebookIcon, InstagramIcon, LinkedinIcon, SendIcon, YoutubeIcon, MusicIcon, LinkIcon } from 'lucide-react';
import { useI18n } from '../../lib/i18n';
import { CONTACT } from '../../lib/data';
export function Footer() {
  const {
    t
  } = useI18n();
  const socials = [{
    href: CONTACT.facebook,
    label: 'Facebook',
    Icon: FacebookIcon
  }, {
    href: CONTACT.instagram,
    label: 'Instagram',
    Icon: InstagramIcon
  }, {
    href: CONTACT.linkedin,
    label: 'LinkedIn',
    Icon: LinkedinIcon
  }, {
    href: CONTACT.telegramChannel,
    label: 'Telegram',
    Icon: SendIcon
  }, {
    href: CONTACT.tiktok,
    label: 'TikTok',
    Icon: MusicIcon
  }, {
    href: CONTACT.linktree,
    label: 'Linktree',
    Icon: LinkIcon
  }];
  return <footer className="border-t border-[rgba(217,217,217,0.1)] bg-navy-deep" data-id="element-56" data-mp="393j8kptfreae">
      <div className="mx-auto max-w-container px-4 py-12 sm:px-6" data-id="element-57" data-mp="2kdd0mo9ycrok">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4" data-id="element-58" data-mp="2kb09bkib14yu">
          <div className="col-span-2 md:col-span-1" data-id="element-59" data-mp="2p4v017wbuk7f">
            <div className="text-lg font-bold text-white brand-glow" data-id="element-60" data-mp="2bcev21jv8c3v">
              SATEV{' '}
              <span className="font-normal text-silver" data-id="element-61" data-mp="2balp6oh2tvwx">
                {t('brand_group')}
              </span>
            </div>
            <p className="mt-2 text-sm text-silver/70" data-id="element-62" data-mp="340kdghng5p0j">
              {t('tagline_company')}
            </p>
          </div>

          <div data-id="element-63" data-mp="381e61obu3rzr">
            <h3 className="text-sm font-semibold uppercase tracking-wide text-white" data-id="element-64" data-mp="381w8x3t054gn">
              {t('company')}
            </h3>
            <ul className="mt-3 space-y-2 text-sm" data-id="element-65" data-mp="2z20rwicrmf8p">
              <li data-id="element-66" data-mp="2z0fxqtud4ybd">
                <Link to="/about" className="text-silver/70 hover:text-white" data-id="element-67" data-mp="2z43sfwbjnqro">
                  {t('nav_about')}
                </Link>
              </li>
              <li data-id="element-68" data-mp="1nn4050p75bxn">
                <Link to="/journey" className="text-silver/70 hover:text-white" data-id="element-69" data-mp="1nnnbtzo97438">
                  {t('nav_journey')}
                </Link>
              </li>
              <li data-id="element-70" data-mp="zje437nih0pv">
                <Link to="/contact" className="text-silver/70 hover:text-white" data-id="element-71" data-mp="ziw4q25jy6dq">
                  {t('nav_contact')}
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-72" data-mp="pu4epzk1xw5g">
            <h3 className="text-sm font-semibold uppercase tracking-wide text-white" data-id="element-73" data-mp="ps9pwa5ntjw3">
              {t('legal')}
            </h3>
            <ul className="mt-3 space-y-2 text-sm" data-id="element-74" data-mp="ks5a6mckst6x">
              <li data-id="element-75" data-mp="fuvn3dcnstm9">
                <Link to="/privacy" className="text-silver/70 hover:text-white" data-id="element-76" data-mp="fudklyzelj5w">
                  {t('privacy_policy')}
                </Link>
              </li>
              <li data-id="element-77" data-mp="6uqjleal6fdd">
                <Link to="/terms" className="text-silver/70 hover:text-white" data-id="element-78" data-mp="6v8i6hkq15og">
                  {t('terms_of_service')}
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-79" data-mp="2188936ujxmb1">
            <h3 className="text-sm font-semibold uppercase tracking-wide text-white" data-id="element-80" data-mp="219t38vcyf38d">
              {t('social')}
            </h3>
            <div className="mt-3 flex flex-wrap gap-3" data-id="element-81" data-mp="28pwkt1lg5ly0">
              {socials.map(({
              href,
              label,
              Icon
            }) => <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className="rounded-md border border-[rgba(217,217,217,0.15)] p-2 text-silver/80 transition-colors hover:border-neon hover:text-neon" data-id="element-82" data-mp="2ihtz4h7r4u0y">
                  <Icon className="h-4 w-4" data-id="element-83" data-mp="1usri9bkxz57i" />
                </a>)}
            </div>
          </div>
        </div>

        <div className="mt-10 border-t border-[rgba(217,217,217,0.1)] pt-6 text-center text-sm text-silver/60" data-id="element-84" data-mp="1ztp17qds03a2">
          © 2026 SATEV Group PLC. {t('rights_reserved')}
        </div>
      </div>
    </footer>;
}